import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DialogRef} from '@progress/kendo-angular-dialog';
import {DtoCustomerAppointment} from "./models/DtoCustomerAppointment";
import {DynamicGridComponent} from "../../fw/dynamic-grids/dynamic-grid.component";
import {DialogWrapperComponent} from "../../fw/dialog-wrapper/dialog-wrapper.component";
import {DialogWrapperConfig} from "../../fw/dialog-wrapper/dialog-wrapper-config";
import {ColumnDefinition} from "../../fw/dynamic-grids/column-definition";
import {SharedService} from "./shared.service";


@Component({
    selector: 'ngx-appointment-list',
    template: require('./appointment-list.component.html'),
    styles: [require('./appointment-list.component.css')]
})
export class AppointmentListComponent implements OnInit, OnDestroy {
    @Input() dialog: DialogRef;
    @Input() data: DtoCustomerAppointment[];
    @Input() employeeId: number;
    @Input() from: Date;
    @Input() untill: Date;
    @Input() caller: string;
    @Input() title: string;
    @Input() infoText: string;
    @Input() isNoteColumn: boolean;
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    @ViewChild('dialogWrapper', {static: true}) dialogWrapper: DialogWrapperComponent;

    wrapperConfig: DialogWrapperConfig = {
        title: [
            {
                text:'MEDEWERKERS',
                isLastStep: false
            },
            {
                text: '',
                isLastStep: true
            }
        ],
        buttonDefinition: [
            {
                description:'AFDRUKKEN',
                isSmall: false,
                clickEventType: 'print'
            },
            {
                description:'SLUITEN',
                isSmall: false,
                clickEventType: 'close'
            }
        ]
    };
    cdAppointments: ColumnDefinition[] = [
        {
            key: 'appointmentDateTime',
            label:'Datum',
            type: 'string',
            width: '110',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'appointmentDateTime',
            label:'Tijd',
            type: 'string',
            width: '80',
            format: '{0:HH:mm}'
        },
        {
            key: 'customer',
            label:'Klant',
            type: 'string',
            width: '*'
        },
        {
            key: 'branch',
            label:'Filiaal',
            type: 'string',
            width: '*'
        }
    ];

    constructor(
        public ss: SharedService,
    ) {
    }

    ngOnInit() {
        this.wrapperConfig.title[1].text = this.title;

        setTimeout(() => {
            this.grid.showData(this.data);
        });
    }

    ngOnDestroy() {
    }

    phbBtnClicked(event) {
        if (event === 'print') {
            this.print();
        } else if (event === 'close') {
            this.closeWindow(false);
        }
    }

    print() {
        if (this.caller === 'EmployeeInactiveComponent') {
            this.ss.showPrintPreview('AppointmentListInactivity', [
                {
                    name: 'employeeId',
                    value: this.employeeId.toString()
                },
                {
                    name: 'from',
                    value: this.ss.formatDate(this.from, 'yyyy-MM-dd')
                },
                {
                    name: 'untill',
                    value: this.ss.formatDate(this.untill, 'yyyy-MM-dd')
                }
            ]);
        } else if (this.caller === 'EmployeeComponent') {
            this.ss.showPrintPreview('AppointmentList', [
                {
                    name: 'employeeId',
                    value: this.employeeId.toString()
                },
                {
                    name: 'date',
                    value: this.ss.formatDate(this.from, 'yyyy-MM-dd')
                },
                {
                    name: 'isNoteColumnList',
                    value: this.isNoteColumn ? 'true' : 'false'
                }
            ]);
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialogWrapper.dialogResult.emit({reload: result});
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/shared/appointment-list.component.ts